[
  {
    "version": "1.1.1",
    "date": "28/06/2026",
    "changes": [
      "Montrer les group passwords des DBs de test ne requiert plus l'introduction d'une raison"
    ]
  },
  {
    "version": "1.1.0",
    "date": "26/06/2026",
    "changes": [
      "Accéder à un mot de passe DB requiert l'introduction d'une raison",
      "La création d'un AppSettings conserve les AppSettings déjà introduit",
      "Module d'opérations en batch ajouté pour les opérations sur de multiple DBs"
    ]
  },
  {
    "version": "1.0.36",
    "date": "06/03/2026",
    "changes": [
      "Ajout de la possibilité de créer des appSettings depuis le cockpit (Admin)",
      "Ajout de la possibilité d'uploader des formTemplates dans une db (En cours de développement)",
      "Dans la liste des appSettings, ajout de l'information sur le type d'appSettings (Crypté ou non crypté)"
    ]
  },
  {
    "version": "1.0.35",
    "date": "09/02/2026",
    "changes": [
      "Ajout du connexion mode dans le rapport getActivesFeaturesByGroupId"
    ]
  },
  {
    "version": "1.0.34",
    "date": "23/01/2026",
    "changes": [
      "Ajout du rapport getActivesFeaturesByGroupId qui affiche les fonctionnalités actives par groupe"
    ]
  },
  {
    "version": "1.0.33",
    "date": "15/12/2025",
    "changes": [
      "Authentification via token bearer",
      "Ajout de la possibilité d'uploader les codes d'assurance dans une db"
    ]
  },
  {
    "version": "1.0.32",
    "date": "31/10/2025",
    "changes": [
      "Ajout des colonnes exportées et du type d'export dans l'onglet reporting "
    ]
  },
  {
    "version": "1.0.31",
    "date": "30/10/2025",
    "changes": [
      "Ajout de la possibilité d'uploader les codes de référence dans une db",
      "Ajout de la possibilité d'uploader les codes du thésaurus dans une db",
      "Ajout de la possibilité d'uploader les tarifications dans une db",
      "Ajout de la possibilité d'uploader les mutuelles dans une db",
      "Modification du style des widgets",
      "Ajout de la langue de l'utilisateur dans l'export (Liste des licences)"
    ]
  },
  {
    "version": "1.0.30",
    "date": "01/10/2025",
    "changes": ["Ajout de la création d'un groupe depuis le cockpit"]
  }
]
